/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-useless-escape */
import { useOutletContext, useParams } from "react-router-dom"
import { useComputed, useSignal } from "@preact/signals-react"

import Button from 'react-bootstrap/Button';
import { Row, Col } from "react-bootstrap";
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal';
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import DatePickerWithIcon from '../../../components/DatePickerWithIcon.jsx'

import { NotificationTypes, addNotification } from "../../../state/actions/notificationActions.js"
import { createTasks } from '../../../state/actions/taskActions.js'

import { TaskTargetType, TaskTargetTypeUtg, TaskTargetTypeUtgConfiguration, TaskTargetTypeUtgStartStop, TaskTargetTypeUtgMiscellaneous, TaskTargetTypeAgent, TaskType } from '../../../utils/constants';
import { scrollToTop } from "../../../utils/utils.js";

function ScheduleTaskModal({ showSignal, handleCancel, selectedUtgsSignal, availableAgentsVersionsSignal, availableUtgVersionsSignal, defaultAgentVersion, defaultUtgVersion, showDownloadProgressSignal, downloadProgressMessageSignal, selectedRowsSignal, isSelectAllSignal }) {

    const { beId } = useParams()
    const { user, config, accessToken, userPermissions, userPermissionsSummary, accordionData: sidebarAccordionData } = useOutletContext()

    const debug = false

    const validatedSignal = useSignal(false)

    // input control state with defaults
    const taskTargetSignal = useSignal(TaskTargetType.Utg)
    const utgTaskTargetSignal = useSignal(TaskTargetTypeUtg.Configuration)
    const utgConfigTaskTargetSignal = useSignal(TaskTargetTypeUtgConfiguration.UpdateUtg)
    const utgSetOfflineTaskTargetSignal = useSignal("1 HOUR")
    const utgStartTaskTargetSignal = useSignal(TaskTargetTypeUtgStartStop.Restart)
    const utgMiscellaneousTaskTargetSignal = useSignal(TaskTargetTypeUtgMiscellaneous.ResetSerialSlot)
    const caseNumberSignal = useSignal('')
    const includeS4dFilesSignal = useSignal(false)
    const includeUtgTraceFilesSignal = useSignal(true)
    const includeAgentLogFilesSignal = useSignal(true)
    const runTaskImmediatelySignal = useSignal(false)
    const defaultDateComputed = useComputed(() => {
        const currentDate = new Date()
        const nextDay = new Date(currentDate)
        nextDay.setDate(currentDate.getDate() + 1) // Move to the next day
        nextDay.setHours(0, 0, 0, 0) // Set time to midnight
        return nextDay;
    })

    const disableSubmitSignal = useSignal(false)

    const selectedDateSignal = useSignal(defaultDateComputed.value)
    const logsStartDateSignal = useSignal(new Date())
    const logsEndDateSignal = useSignal(defaultDateComputed.value)
    const agentTaskTargetSignal = useSignal(TaskTargetTypeAgent.DeployAgentVerson)
    const utgDeployTaskTargetSignal = useSignal(defaultUtgVersion)
    const agentDeployTaskTargetSignal = useSignal(defaultAgentVersion)

    const taskObjectSignal = useSignal({})
    const bulkLabelSignal = useSignal('')

    const buildTaskObjectArray = () => {
        let tempTaskObjectArray = []
        selectedUtgsSignal.value.forEach(
            (utg) => {
                const newTaskObject = {
                    businessEntityId: utg.businessEntityId,
                    componentId: utg.componentId,
                    hash: null,
                    instructions: taskObjectSignal.value.instructions,
                    lastUpdatedAt: taskObjectSignal.value.lastUpdatedAt,
                    lastUpdatedBy: 1,
                    machinePermanentId: utg.machinePermanentId,
                    resultDetails: null,
                    resultMessage: null,
                    runAfter: taskObjectSignal.value.runAfter,
                    signature: null,
                    status: 0,
                    taskGroupId: null,
                    type: taskObjectSignal.value.type,
                    version: null,
                    bulkLabel: bulkLabelSignal.value.length ? bulkLabelSignal.value : null,
                    label: bulkLabelSignal.value.length ? bulkLabelSignal.value : null
                }
                tempTaskObjectArray.push(newTaskObject)
            }
        )
        return tempTaskObjectArray
    }

    const sortedUtgVersionsComputed = useComputed(
        () => {
            let _sortedData = [...availableUtgVersionsSignal.value]
            const prefix = "track ga (currently: "
            return _sortedData.sort(
                (a, b) => {
                    let _a = a.version
                    let _b = b.version
                    _a = _a ? _a : ''
                    _b = _b ? _b : ''
                    if (_a && _a.length) {
                        _a = _a.toLowerCase()
                    }
                    if (_b && _b.length) {
                        _b = _b.toLowerCase()
                    }
                    if (_a < _b || _a.startsWith(prefix)) {
                        return -1
                    }
                    if (_a > _b || _b.startsWith(prefix)) {
                        return 1
                    }
                    return 0
                }
            )
        }
    )

    const handleSubmitModalTask = async () => {
        const f = "handleSubmitModalTask()"

        disableSubmitSignal.value = true
        showSignal.value = false

        taskObjectSignal.value.lastUpdatedAt = new Date().toISOString()

        if (runTaskImmediatelySignal.value) {
            taskObjectSignal.value.runAfter = new Date().toISOString()
        }
        if (selectedDateSignal.value && !runTaskImmediatelySignal.value) {
            taskObjectSignal.value.runAfter = selectedDateSignal.value.toISOString()
        }

        // DeployUtgVersion
        if (taskTargetSignal.value == TaskTargetType.Utg && utgTaskTargetSignal.value == TaskTargetTypeUtg.DeployUtgVersion) {
            const selectedUtg = availableUtgVersionsSignal.value.filter((utg) => utg.version === utgDeployTaskTargetSignal.value)
            taskObjectSignal.value.type = TaskType[utgTaskTargetSignal.value]
            taskObjectSignal.value.instructions = `{\"downloadLocation\":\"${selectedUtg[0]?.downloadLocation || ""}\"}`
        }

        // SetOffline
        if (taskTargetSignal.value == TaskTargetType.Utg && utgTaskTargetSignal.value == TaskTargetTypeUtg.SetOffline) {
            taskObjectSignal.value.type = TaskType[utgTaskTargetSignal.value]
            taskObjectSignal.value.instructions = `{\"offlineTime\":\"${utgSetOfflineTaskTargetSignal.value}\"}`
        }

        // Configuration
        if (taskTargetSignal.value == TaskTargetType.Utg && utgTaskTargetSignal.value == TaskTargetTypeUtg.Configuration) {
            taskObjectSignal.value.type = TaskType[utgConfigTaskTargetSignal.value]
            taskObjectSignal.value.instructions = null
            if (utgConfigTaskTargetSignal.value == TaskTargetTypeUtgConfiguration.RollbackUtg) {
                taskObjectSignal.value.instructions = "{\"Destination\": 5}"
            }
            if (utgConfigTaskTargetSignal.value == TaskTargetTypeUtgConfiguration.UpdateCommandCenter) {
                taskObjectSignal.value.instructions = "{\"Destination\": 10}"
            }
        }

        // Miscellaneous
        if (taskTargetSignal.value == TaskTargetType.Utg && utgTaskTargetSignal.value == TaskTargetTypeUtg.Miscellaneous) {
            taskObjectSignal.value.type = TaskType[utgMiscellaneousTaskTargetSignal.value]
        }

        // StartStop
        if (taskTargetSignal.value == TaskTargetType.Utg && utgTaskTargetSignal.value == TaskTargetTypeUtg.StartStop) {
            taskObjectSignal.value.type = TaskType[utgStartTaskTargetSignal.value]
            taskObjectSignal.value.instructions = null
            if (utgStartTaskTargetSignal.value == TaskTargetTypeUtgStartStop.Start || utgStartTaskTargetSignal.value == TaskTargetTypeUtgStartStop.Restart) {
                taskObjectSignal.value.instructions = "{\"ComponentRunningMode\": 1}"
            }
        }

        // DeployAgentVerson
        if (taskTargetSignal.value == TaskTargetType.Agent && agentTaskTargetSignal.value == TaskTargetTypeAgent.DeployAgentVerson) {
            const selectedAgent = availableAgentsVersionsSignal.value.filter((a) => a.version === agentDeployTaskTargetSignal.value)
            taskObjectSignal.value.type = TaskType[agentTaskTargetSignal.value]
            taskObjectSignal.value.instructions = `{\"downloadLocation\":\"${selectedAgent[0]?.downloadLocation || ""}\"}`
        }

        // UploadLogs Agent
        if (taskTargetSignal.value == TaskTargetType.Agent && agentTaskTargetSignal.value == TaskTargetTypeAgent.UploadLogs) {
            taskObjectSignal.value.type = TaskType[agentTaskTargetSignal.value]
            let instructions = {
                StartDate: new Date(1970, 1).toISOString(),
                EndDate: new Date(2070, 1).toISOString(),
                Label: caseNumberSignal.value.trim().replace(/\s+/g, '_'),
                includeS4dFiles: includeS4dFilesSignal.value,
                includeUtgTraceFiles: includeUtgTraceFilesSignal.value,
                includeAgentLogs: true
            }
            taskObjectSignal.value.instructions = JSON.stringify(instructions)

        }

        //UploadLogs Utg
        if (taskTargetSignal.value == TaskTargetType.Utg && utgTaskTargetSignal.value == TaskTargetTypeUtg.UploadLogs) {
            taskObjectSignal.value.type = TaskType[utgTaskTargetSignal.value]
            let instructions = {
                StartDate: new Date(1970, 1).toISOString(),
                EndDate: new Date(2070, 1).toISOString(),
                Label: caseNumberSignal.value.trim().replace(/\s+/g, '_'),
                includeS4dFiles: includeS4dFilesSignal.value,
                includeAgentLogs: includeAgentLogFilesSignal.value,
                includeUtgTraceFiles: true
            }
            taskObjectSignal.value.instructions = JSON.stringify(instructions)
        }

        // Build the task object array
        const tasks = buildTaskObjectArray()

        //const tasks = taskObjectArray.value
        //taskObjectArray.value = []
        //console.log(tasks)
        
        if (tasks.length) {
            //console.log(f.concat(": ").concat(tasks.length).concat(" tasks to create"))
            downloadProgressMessageSignal.value = `Creating ${tasks.length.toString()} task(s).`
            showDownloadProgressSignal.value = true
            scrollToTop("main")
            //console.log(f.concat(": submtting tasks"))
            createTasks(beId, tasks, config, accessToken, false).then(
                (createTasksResult) => {
                    console.log(createTasksResult)
                    scrollToTop("main")
                    addNotification(`${tasks.length.toString()} task(s) created successfully.`, NotificationTypes.SUCCESS, true)
                    reinitializeForm()
                }
            ).finally(
                () => {
                    disableSubmitSignal.value = false
                    showDownloadProgressSignal.value = false
                }
            )
        } else {
            disableSubmitSignal.value = false
            throw new Error("Tasks array is empty")
        }
    }

    const reinitializeForm = () => {
        taskTargetSignal.value = TaskTargetType.Utg
        utgTaskTargetSignal.value = TaskTargetTypeUtg.Configuration
        utgConfigTaskTargetSignal.value = TaskTargetTypeUtgConfiguration.UpdateUtg
        utgSetOfflineTaskTargetSignal.value = "1 HOUR"
        utgStartTaskTargetSignal.value = TaskTargetTypeUtgStartStop.Restart
        utgMiscellaneousTaskTargetSignal.value = TaskTargetTypeUtgMiscellaneous.ResetSerialSlot
        caseNumberSignal.value = ''
        includeS4dFilesSignal.value = false
        includeAgentLogFilesSignal.value = true
        includeUtgTraceFilesSignal.value = true
        runTaskImmediatelySignal.value = false
        //taskObjectArray.value = []
        selectedDateSignal.value = defaultDateComputed.value
        agentTaskTargetSignal.value = TaskTargetTypeAgent.DeployAgentVerson
        utgDeployTaskTargetSignal.value = defaultUtgVersion
        agentDeployTaskTargetSignal.value = defaultAgentVersion
        taskObjectSignal.value = {}
        bulkLabelSignal.value = ''

        selectedRowsSignal.value = []
        isSelectAllSignal.value = false
    }

    const handleTaskTargetChange = e => {
        console.log(e.target.value)
        taskTargetSignal.value = e.target.value
    }

    const handleTaskRunDateChange = (date) => {
        selectedDateSignal.value = date
        console.log(selectedDateSignal.value.toISOString())
    }

    function AgentVersionSelect() {
        if (availableAgentsVersionsSignal.value) {
            let items = availableAgentsVersionsSignal.value.map(a => {
                return (
                    <option value={a.version} key={a.version}>{a.version}</option>
                )
            })

            return (
                <Form.Select onInput={(e) => agentDeployTaskTargetSignal.value = e.target.value} value={agentDeployTaskTargetSignal.value}>
                    {items}
                </Form.Select>
            )
        }
    }

    function UtgVersionSelect() {
        if (sortedUtgVersionsComputed.value) {
            console.log(typeof sortedUtgVersionsComputed.value)
            let items = sortedUtgVersionsComputed.value.map(a => {
                return (
                    <option value={a.version} key={a.version}>{a.version}</option>
                )
            })

            return (
                <Form.Select onInput={(e) => utgDeployTaskTargetSignal.value = e.target.value} value={utgDeployTaskTargetSignal.value}>
                    {items}
                </Form.Select>
            )
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        const form = event.target
        //validatedSignal.value = true
        if (form.checkValidity() === false) {
            return
        }
        
        handleSubmitModalTask()
    }

    return (
        <Modal show={showSignal.value} onHide={handleCancel} size="lg">
            <Form noValidate validated={validatedSignal.value} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>Schedule Task</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Task will be created for {selectedUtgsSignal.value.length} selected UTG(s)</p>
                    <Form.Group className="mb-3" controlId="taskTarget">
                        <Form.Label>Schedule for</Form.Label>
                        <Form.Select onInput={(event) => handleTaskTargetChange(event)}>
                            <option value={TaskTargetType.Utg}>UTG</option>
                            <option value={TaskTargetType.Agent}>Agent</option>
                        </Form.Select>
                    </Form.Group>

                    {/* Utg Tasks */}

                    {(taskTargetSignal.value === TaskTargetType.Utg) && (
                        <Form.Group className="mb-3" controlId="utgTaskTargetSignal">
                            <Form.Label>Task</Form.Label>
                            <Form.Select onInput={(e) => utgTaskTargetSignal.value = e.target.value} value={utgTaskTargetSignal.value == null ? TaskTargetTypeUtg.Configuration : utgTaskTargetSignal.value}>
                                <option value={TaskTargetTypeUtg.Configuration}>Configuration Changes</option>
                                <option value={TaskTargetTypeUtg.DeployUtgVersion}>Deploy UTG Version</option>
                                <option value={TaskTargetTypeUtg.Miscellaneous}>Miscellaneous</option>
                                <option value={TaskTargetTypeUtg.SetOffline}>Set Offline Mode</option>
                                <option value={TaskTargetTypeUtg.StartStop}>Start/Stop</option>
                                <option value={TaskTargetTypeUtg.UploadLogs}>Upload Logs</option>
                            </Form.Select>
                            <hr />
                        </Form.Group>
                    )}

                    {/* Utg Configuration Tasks */}

                    {(taskTargetSignal.value === TaskTargetType.Utg &&
                        utgTaskTargetSignal.value === TaskTargetTypeUtg.Configuration) && (
                            <Form.Group className="mb-3" controlId="utgConfigurationTaskTarget">
                                <Form.Check type='radio' name={TaskTargetTypeUtg.Configuration} id={TaskTargetTypeUtgConfiguration.UpdateUtg} label={`Update UTG`}
                                    checked={utgConfigTaskTargetSignal.value == TaskTargetTypeUtgConfiguration.UpdateUtg}
                                    onChange={() => utgConfigTaskTargetSignal.value = TaskTargetTypeUtgConfiguration.UpdateUtg} />
                                <Form.Check type='radio' name={TaskTargetTypeUtg.Configuration} id={TaskTargetTypeUtgConfiguration.RollbackUtg} label={`Rollback UTG`}
                                    checked={utgConfigTaskTargetSignal.value == TaskTargetTypeUtgConfiguration.RollbackUtg}
                                    onChange={() => utgConfigTaskTargetSignal.value = TaskTargetTypeUtgConfiguration.RollbackUtg} />
                                <Form.Check type='radio' name={TaskTargetTypeUtg.Configuration} id={TaskTargetTypeUtgConfiguration.UpdateCommandCenter} label={`Update Command Center`}
                                    checked={utgConfigTaskTargetSignal.value == TaskTargetTypeUtgConfiguration.UpdateCommandCenter}
                                    onChange={() => utgConfigTaskTargetSignal.value = TaskTargetTypeUtgConfiguration.UpdateCommandCenter} />
                                {(utgConfigTaskTargetSignal.value === TaskTargetTypeUtgConfiguration.UpdateUtg) && (
                                    <Form.Text muted>Stops the UTG, updates it to the current Command Center configuration, then restarts it as a service.</Form.Text>
                                )}
                                {(utgConfigTaskTargetSignal.value === TaskTargetTypeUtgConfiguration.RollbackUtg) && (
                                    <Form.Text muted>Stops the UTG, rolls it back to the previous configuration, then restarts it as a service.</Form.Text>
                                )}
                                {(utgConfigTaskTargetSignal.value === TaskTargetTypeUtgConfiguration.UpdateCommandCenter) && (
                                    <Form.Text muted>Updates Command Center to the UTG&apos;s current configuration.</Form.Text>
                                )}
                            </Form.Group>
                        )}

                    {/* Deploy UTG */}

                    {(taskTargetSignal.value === TaskTargetType.Utg &&
                        utgTaskTargetSignal.value === TaskTargetTypeUtg.DeployUtgVersion) && (
                            <Form.Group className="mb-3" controlId="availableUtgs">
                                <Form.Label>UTG Version</Form.Label>
                                <UtgVersionSelect />
                            </Form.Group>
                        )}

                    {/* Utg Miscellaneous Tasks */}

                    {(taskTargetSignal.value === TaskTargetType.Utg &&
                        utgTaskTargetSignal.value === TaskTargetTypeUtg.Miscellaneous) && (
                            <Form.Group className="mb-3" controlId="utgMiscellaneousTaskTargetSignal">
                                <Form.Check type='radio' name={TaskTargetTypeUtg.Miscellaneous} id={TaskTargetTypeUtgMiscellaneous.ResetSerialSlot} label={`Reset UTG Slot`}
                                    checked={utgMiscellaneousTaskTargetSignal.value == TaskTargetTypeUtgMiscellaneous.ResetSerialSlot}
                                    onChange={() => utgMiscellaneousTaskTargetSignal.value = TaskTargetTypeUtgMiscellaneous.ResetSerialSlot} />
                                {(utgMiscellaneousTaskTargetSignal.value === TaskTargetTypeUtgMiscellaneous.ResetSerialSlot) && (
                                    <Form.Text muted>The slot is what ties the UTG to the machine. If the UTG is moved to another machine (or if the IP address changes) the slot must be reactivated.</Form.Text>
                                )}
                            </Form.Group>
                        )}

                    {/* Utg Set Offline */}

                    {(taskTargetSignal.value === TaskTargetType.Utg &&
                        utgTaskTargetSignal.value === TaskTargetTypeUtg.SetOffline) && (
                            <Form.Group className="mb-3" controlId="utgSetOfflineTaskTargetSignal">
                                <Form.Label>Offline Mode Duration</Form.Label>
                                <Form.Select onInput={(e) => utgSetOfflineTaskTargetSignal.value = e.target.value} value={utgSetOfflineTaskTargetSignal.value == null ? "1 HOUR" : utgSetOfflineTaskTargetSignal.value}>
                                    <option value="1 HOUR">1 hour</option>
                                    <option value="4 HOURS">4 hours</option>
                                    <option value="8 HOURS">8 hours</option>
                                    <option value="12 HOURS">12 hours</option>
                                    <option value="16 HOURS">16 hours</option>
                                    <option value="20 HOURS">20 hours</option>
                                    <option value="24 HOURS">24 hours</option>
                                </Form.Select>
                            </Form.Group>
                        )}

                    {/* Utg Start/Stop Tasks */}

                    {(taskTargetSignal.value === TaskTargetType.Utg &&
                        utgTaskTargetSignal.value === TaskTargetTypeUtg.StartStop) && (
                            <Form.Group className="mb-3" controlId="utgStartTaskType">
                                <Form.Check type='radio' name={TaskTargetTypeUtg.StartStop} id={TaskTargetTypeUtgStartStop.Restart} label={`Restart UTG`}
                                    checked={utgStartTaskTargetSignal.value == TaskTargetTypeUtgStartStop.Restart}
                                    onChange={() => utgStartTaskTargetSignal.value = TaskTargetTypeUtgStartStop.Restart} />
                                <Form.Check type='radio' name={TaskTargetTypeUtg.StartStop} id={TaskTargetTypeUtgStartStop.Start} label={`Start UTG`}
                                    checked={utgStartTaskTargetSignal.value == TaskTargetTypeUtgStartStop.Start}
                                    onChange={() => utgStartTaskTargetSignal.value = TaskTargetTypeUtgStartStop.Start} />
                                <Form.Check type='radio' name={TaskTargetTypeUtg.StartStop} id={TaskTargetTypeUtgStartStop.Stop} label={`Stop UTG`}
                                    checked={utgStartTaskTargetSignal.value == TaskTargetTypeUtgStartStop.Stop}
                                    onChange={() => utgStartTaskTargetSignal.value = TaskTargetTypeUtgStartStop.Stop} />
                                {(utgStartTaskTargetSignal.value === TaskTargetTypeUtgStartStop.Restart) && (
                                    <Form.Text muted>Stops and then restart the UTG as a service.</Form.Text>
                                )}
                                {(utgStartTaskTargetSignal.value === TaskTargetTypeUtgStartStop.Start) && (
                                    <Form.Text muted>Starts the UTG as a service.</Form.Text>
                                )}
                                {(utgStartTaskTargetSignal.value === TaskTargetTypeUtgStartStop.Stop) && (
                                    <Form.Text muted>Stops the UTG whether running as a service or standalone.</Form.Text>
                                )}
                            </Form.Group>
                        )}

                    {/* Upload Logs Utg */}

                    {(taskTargetSignal.value === TaskTargetType.Utg &&
                        utgTaskTargetSignal.value === TaskTargetTypeUtg.UploadLogs) && (<>
                            <Form.Group className="mb-3" controlId="utgUploadLogsUtgS4D">
                                <Form.Check checked={includeS4dFilesSignal.value} onChange={() => { includeS4dFilesSignal.value = !includeS4dFilesSignal.value }} type="checkbox" label="Include UTG .s4d files"></Form.Check>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="utgUploadLogsUtgAgentLogs">
                                <Form.Check checked={includeAgentLogFilesSignal.value} onChange={() => { includeAgentLogFilesSignal.value = !includeAgentLogFilesSignal.value }} type="checkbox" label="Include Agent log files"></Form.Check>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="utgUploadLogsUtgCase">
                                <Form.Label className="d-block mt-3">Case Number</Form.Label>
                                <Form.Control type="text" className="d-block" placeholder="Case Number" required onChange={(event) => caseNumberSignal.value = event.target.value} value={caseNumberSignal.value} isValid={caseNumberSignal.value.trim().length > 0} isInvalid={caseNumberSignal.value.trim().length == 0} />
                                <Form.Control.Feedback type="invalid">Please provide a case number or short text description to identify this request.</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="agentUploadLogsDays">
                                <Form.Label>Notes</Form.Label>
                                <Form.Text className="d-block">Agent Logs and UTG Trace files are available for 7 days by default.</Form.Text>
                                <Form.Text className="d-block">Including .s4d files will cause the UTG to be stopped and restarted.</Form.Text>
                            </Form.Group>
                        </>)}

                    {/* Agent Tasks */}

                    {(taskTargetSignal.value === TaskTargetType.Agent) && (
                        <Form.Group className="mb-3" controlId="agentTaskType.ControlInput">
                            <Form.Label>Task</Form.Label>
                            <Form.Select onInput={(e) => agentTaskTargetSignal.value = e.target.value} value={agentTaskTargetSignal.value == null ? TaskTargetTypeAgent.DeployAgentVerson : agentTaskTargetSignal.value}>
                                <option value={TaskTargetTypeAgent.DeployAgentVerson}>Deploy Agent Version</option>
                                <option value={TaskTargetTypeAgent.UploadLogs}>Upload Logs</option>
                            </Form.Select>
                            <hr />
                        </Form.Group>
                    )}

                    {/* Deploy Agent Version */}

                    {(taskTargetSignal.value === TaskTargetType.Agent &&
                        agentTaskTargetSignal.value === TaskTargetTypeAgent.DeployAgentVerson) && (
                            <Form.Group className="mb-3" controlId="availableAgents.ControlInput">
                                <Form.Label>Agent Version</Form.Label>
                                <AgentVersionSelect></AgentVersionSelect>
                            </Form.Group>
                        )}

                    {/* Upload Logs Agent */}

                    {(taskTargetSignal.value === TaskTargetType.Agent &&
                        agentTaskTargetSignal.value === TaskTargetTypeAgent.UploadLogs) && (<>
                            <Form.Group className="mb-3" controlId="agentUploadLogsS4D">
                                <Form.Check checked={includeS4dFilesSignal.value} onChange={() => { includeS4dFilesSignal.value = !includeS4dFilesSignal.value }} type="checkbox" label="Include UTG .s4d files"></Form.Check>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="agentUploadLogsTrace">
                                <Form.Check checked={includeUtgTraceFilesSignal.value} onChange={() => { includeUtgTraceFilesSignal.value = !includeUtgTraceFilesSignal.value }} type="checkbox" label="Include UTG trace files"></Form.Check>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="agentUploadLogsCase">
                                <Form.Label className="d-block mt-3">Case Number</Form.Label>
                                <Form.Control type="text" className="d-block" placeholder="Case Number" required onChange={(event) => caseNumberSignal.value = event.target.value} value={caseNumberSignal.value} isValid={caseNumberSignal.value.trim().length > 0} isInvalid={caseNumberSignal.value.trim().length == 0} />
                                <Form.Control.Feedback type="invalid">Please provide a case number or short text description to identify this request.</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="agentUploadLogsDays">
                                <Form.Label>Notes</Form.Label>
                                <Form.Text className="d-block">Agent Logs and UTG Trace files are available for 7 days by default.</Form.Text>
                                <Form.Text className="d-block">Including .s4d files will cause the UTG to be stopped and restarted.</Form.Text>
                            </Form.Group>
                        </>)}

                    <hr />
 
                    <Tabs defaultActiveKey="future" onSelect={(eventKey) => { runTaskImmediatelySignal.value = eventKey == 'immediate'}}>
                        <Tab eventKey="future" title="Future Task" className="bg-light border-start border-end border-bottom p-2" >
                            <Form.Group controlId="agentTaskType.ControlInput">
                                <Form.Text className="d-block">Select your local date and time when this task should start.</Form.Text>
                                <Form.Label className="d-block">Task Run Date</Form.Label>
                                <DatePickerWithIcon
                                    className="d-block form-control"
                                    showTimeSelect
                                    onChange={handleTaskRunDateChange}
                                    selected={selectedDateSignal.value}
                                    timeFormat="HH:mm"
                                    timeIntervals={30} // Interval in minutes for the time picker
                                    timeCaption="Time" // Caption for the time picker
                                    dateFormat="yyyy-MM-dd h:mm aa" // Include both date and time
                                    shouldCloseOnSelect={true}
                                />
                                <Form.Text className="d-block">UTC: {selectedDateSignal.value.toISOString()}.</Form.Text>
                            </Form.Group>
                        </Tab>
                        <Tab eventKey="immediate" title="Immediate Task" className="bg-light border-start border-end border-bottom p-2" >
                            <Form.Group controlId="runImmediately.ControlInput">
                                <Form.Check checked={runTaskImmediatelySignal.value} onChange={() => { runTaskImmediatelySignal.value = !runTaskImmediatelySignal.value }} type="checkbox" label="Run Immediately"></Form.Check>
                            </Form.Group>
                        </Tab>
                    </Tabs>

                    <hr />
                    <Form.Group className="mb-3" controlId="taskLabel.ControlInput">
                        <Form.Label className="d-block">Task Label</Form.Label>
                        <Form.Control type="text" className="d-block" placeholder="Optional task label" onChange={(event) => bulkLabelSignal.value = event.target.value} value={bulkLabelSignal.value} />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button type="submit" disabled={disableSubmitSignal.value}>Apply</Button>
                </Modal.Footer>
                <div hidden={!debug}>
                    <div>Task target type: {taskTargetSignal.value}</div>
                    <div>UTG task type: {utgTaskTargetSignal.value}</div>
                    <div>Agent task type: {agentTaskTargetSignal.value}</div>
                    <div>Offline time: {utgSetOfflineTaskTargetSignal.value}</div>
                </div>
            </Form>
        </Modal>

    )
}

export default ScheduleTaskModal